export const SET_USERINFO = 'SET_USERINFO';
export const SET_BALANCE = 'SET_BALANCE';
export const SET_PENGING = 'SET_PENGING';
export const SET_TODAYRATE = 'SET_TODAYRATE';
export const SET_PENDING = 'SET_PENDING';